import type { ChangeEvent, FC } from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalSearchResult } from '~/modules/global-search/GlobalSearchResult.tsx';
import { SearchInput } from '~/modules/global-search/SearchInput.tsx';
import { useSearch } from '~/modules/global-search/useSearch.hook.ts';

export type GlobalSearchProps = {
  onChange?: (value: string) => void;
};

export const GlobalSearch: FC<GlobalSearchProps> = ({ onChange }) => {
  const { t } = useTranslation('wmgone');
  const [value, setValue] = useState('');

  const search = useSearch(value);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      onChange?.(e.target.value);
    },
    [onChange],
  );

  const handleClear = useCallback(() => {
    setValue('');
    onChange?.('');
  }, [onChange]);

  return (
    <div className="flex py-sm px-sm justify-center bg-default">
      <div className="w-full max-w-[37.5rem] relative">
        <SearchInput
          placeholder={t('globalSearch.inputPlaceholder')}
          value={value}
          onChange={handleChange}
          onClear={handleClear}
        />
        <GlobalSearchResult
          visible={Boolean(value)}
          items={search}
          searchValue={value}
        />
      </div>
    </div>
  );
};

GlobalSearch.displayName = 'GlobalSearch';
